export enum Policy {
	NoOne = 'NoOne',
	UsersOnly = 'UsersOnly',
	Everyone = 'Everyone',
}
